/** Names of the stock transfer routes (CORA-351), shared by the router and the screens that link to them. */
export const StockTransferRoute = {
  List: 'WarehouseTransfers',
  New: 'WarehouseTransferNew',
  Detail: 'WarehouseTransferDetail',
  Edit: 'WarehouseTransferEdit',
} as const;
export type StockTransferRoute = (typeof StockTransferRoute)[keyof typeof StockTransferRoute];

// The roles of the /stock-transfers API.
export const STOCK_TRANSFER_ROLES = ['admin', 'hospital_admin', 'stock_manager'];
